module.exports = __webpack_public_path__ + "media/ko_kr_s3_SangOok.89889d22.oga";